<template>
    <div class="w-full">
        <!-- Playlist Header -->
        <div class="bg-gradient-to-r from-nomad-800 to-nomad-900 rounded-lg overflow-hidden mb-8 p-6 md:p-8">
            <div class="text-center">
                <h1 class="text-white font-bold text-3xl md:text-5xl mb-2">{{ playlist.name }}</h1>
                <p class="text-nomad-300" v-if="playlist.songs_count > 0">
                    {{ playlist.songs_count }} {{ playlist.songs_count === 1 ? 'song' : 'songs' }}
                </p>
            </div>
        </div>

        <!-- Songs Grid -->
        <div v-if="playlist.songs && playlist.songs.length">
            <ul class="grid grid-cols-1 gap-3">
                <li v-for="song in playlist.songs" :key="song.id">
                    <CardSong :song="song" />
                </li>
            </ul>
        </div>

        <!-- Empty State -->
        <div v-else class="text-center py-12">
            <p class="text-nomad-300 text-lg">No songs in this playlist yet</p>
        </div>
    </div>
</template>
<script setup>
defineProps({ playlist: Object });
</script>
<script>
import { defineAsyncComponent } from 'vue'
import { mapState, mapActions } from "vuex";
import { usePage, Link } from "@inertiajs/vue3";
import CardSong from '@/components/CardSong.vue'
export default {
    methods: {
        ...mapActions("playlist", ["getSinglePlaylist"]),
    },
    beforeMount() {
        document.title = this.playlist.name + ' Heeso - Playlist'
    },
    components: {
        'adsense': defineAsyncComponent(() => import("@/components/Adsense.vue")),
        CardSong
    }
};
</script>